import { render, staticRenderFns } from "./detailEdit.vue?vue&type=template&id=66122fd7&"
import script from "./detailEdit.vue?vue&type=script&lang=js&"
export * from "./detailEdit.vue?vue&type=script&lang=js&"
import style0 from "./detailEdit.vue?vue&type=style&index=0&id=66122fd7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports